
$(function() {
	$('.infobox-popup').popup();
});
